import { render, staticRenderFns } from "./agenda-relacao.vue?vue&type=template&id=c959daa8&scoped=true"
import script from "./agenda-relacao.vue?vue&type=script&lang=js"
export * from "./agenda-relacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c959daa8",
  null
  
)

export default component.exports